export type ObjectValues<T> = T[keyof T]
export const CMS_DATA_ID = {
  SEARCH: "Search",
  NAVIGATION: "Navigation",
  OVERVIEW: "OverviewData",
  NEWSLETTER: "Newsletter",
  NEWSLETTER_FOOTER: "NewsletterFooter",
  MAP: "Map",
  DONATION: "Donation"
} as const

export type CmsDataId = ObjectValues<typeof CMS_DATA_ID>

class CmsDataProvider {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private data: Record<string, any>
  constructor() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.data = (window as any).__CMS_DATA || {}
  }

  get<T>(id: CmsDataId): T {
    const data = this.data[id]
    if (!data) {
      throw new TypeError(`no data available for id: '${id}'`)
    }
    return data
  }
}

export const CMSDataProvider = new CmsDataProvider()
